/* Registro de themes del hub — la fuente ÚNICA de qué themes hay.
 *
 * Sumar un theme nuevo es agregar UNA entrada acá y su bloque de tokens en el
 * CSS bajo `:root[data-theme="<id>"]`. Nadie más tiene que saber la lista: la
 * pantalla de Preferencias la lee de acá, y la resolución claro/oscuro de lo
 * que se pinta en JS (gráficos, acento) sale de `baseDeTema`.
 *
 * ── QUÉ ES `base` ────────────────────────────────────────────────────────────
 *
 * El hub resuelve casi todo el tema con CSS, pero hay cosas que se deciden en
 * JS y necesitan saber si el fondo es claro u oscuro: la paleta de los gráficos
 * (`shared/tema.js`) y la variante del color de acento (`functions/preferencias
 * .js`). `base` es justamente eso —"light" | "dark"— para cada theme.
 *
 *   - `auto`  no tiene base fija: manda el sistema operativo (por eso no setea
 *             `data-theme` y `base` queda sin definir → lo resuelve el SO).
 *   - un theme con su propia identidad visible (ej. "industrial") declara acá
 *     si su fondo es claro u oscuro, y todo lo demás se acomoda solo.
 */

export const TEMAS = [
  { id: "auto", label: "Automático" },
  { id: "light", label: "Claro", base: "light" },
  { id: "dark", label: "Oscuro", base: "dark" },
  /* Industrial va OCULTO: existe (se puede aplicar con ?theme=industrial para
     revisarlo), pero NO se ofrece en Preferencias hasta que el rediseño esté
     completo (tokens + hex migrados + armazón). Un `oculto` que se expone a
     medias hace que alguien caiga en un tema incompleto. */
  { id: "industrial", label: "Industrial", base: "light", oculto: true },
];

/* Los themes que SÍ se ofrecen en Preferencias (sin los ocultos/en pruebas). */
export function temasVisibles() {
  return TEMAS.filter((t) => !t.oculto);
}

/* El modo claro/oscuro de un theme, para lo que se resuelve en JS. Devuelve
 * "light" | "dark", o `null` cuando no hay base fija (automático / theme
 * desconocido) y hay que preguntarle al sistema operativo. */
export function baseDeTema(id) {
  return TEMAS.find((t) => t.id === id)?.base ?? null;
}

/* ¿Es un id de theme que conocemos? Sirve para no setear `data-theme` con
 * cualquier cosa. */
export function existeTema(id) {
  return TEMAS.some((t) => t.id === id);
}
